import { render, staticRenderFns } from "./TicketPop.vue?vue&type=template&id=677a2b56"
import script from "./TicketPop.vue?vue&type=script&lang=js"
export * from "./TicketPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports